<template>
  <div :class="['table-container', className]">
    <h3
      v-if="title"
      class="table-title"
    >{{ title }}</h3>
    <div class="table-shadow">
      <v-simple-table :style="{ minWidth: minWidth ?? 0 }">
        <slot />
      </v-simple-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportTable',
  props: ['className', 'minWidth', 'title'],
};
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';

$table-border-color: #e2e8f0;
$table-title-color: #133b54;
$table-header-border-color: #1a365c;
$table-header-color: #718096;
$table-cell-color: #2d3748;
$table-active-cell-background-color: #b0d35e;
$table-hidden-cell-background-color: #e3e3e3;
$table-hidden-cell-color: #636363;

.table-container {
  padding: 12px;

  .table-shadow {
    border: 1px solid $table-border-color;
    border-radius: 12px;
    box-shadow: $shadow-md !important;
    overflow-x: auto;
  }

  .table-title {
    color: $table-title-color;
    margin-bottom: 5px;
    padding-left: 10px;
  }

  :deep(table) {
    max-width: 100%;
    overflow: hidden;

    thead > tr > th {
      border-bottom: 1px solid $table-header-border-color !important;

      &:first-of-type {
        border-radius: 8px 0 0 0;
      }

      &:last-of-type {
        border-radius: 0 8px 0 0;
      }

      span {
        color: $table-header-color !important;
        font-size: 13px;
        font-weight: 600;
      }
    }

    td {
      color: $table-cell-color;
      font-size: 14px !important;
    }

    .active td {
      background-color: $table-active-cell-background-color;
    }

    .median td {
      font-size: 12px !important;
      opacity: 0.7;
      height: 28px !important;
      padding: 2px 16px !important;
    }

    .hidden td {
      background-color: $table-hidden-cell-background-color;
      color: $table-hidden-cell-color;
    }
  }
}
</style>
